import { richText } from '../../validators';
import { trimSpacesLeft } from '../../formatters';

export enum MeetingConnectionFields {
    MEETING_CONNECTION_NOTES = 'meetingConnectionNotes',
    MEETING_RECORD_ENABLED = 'meetingRecordEnabled',
    AUTO_REGISTRATION_ENABLED = 'autoRegistrationEnabled',
    AUTO_SUBSCRIPTION_ENABLED = 'autoSubscriptionEnabled',
}

const _config = {
    [MeetingConnectionFields.MEETING_CONNECTION_NOTES]: {
        label: 'Meeting Connection Notes',
        validators: [ richText.maxLength.short ],
        formatters: [ trimSpacesLeft ]
    },
    [MeetingConnectionFields.MEETING_RECORD_ENABLED]: {
        label: 'Record Meeting',
        defaultValue: false,
        formatters: [ Boolean ],
    },
    [MeetingConnectionFields.AUTO_REGISTRATION_ENABLED]: {
        defaultValue: false,
        formatters: [ Boolean ],
    },
    [MeetingConnectionFields.AUTO_SUBSCRIPTION_ENABLED]: {
        defaultValue: false,
        formatters: [ Boolean ],
    },
};

export default Object
    .entries(_config)
    .map(([key, cnf]) => ({ name: key, ...cnf }))
;
